import { apiRequest } from "./client";

function safeId(value) {
  return encodeURIComponent(String(value || "").trim());
}

export const recipesApi = {
  list(projectId) {
    return apiRequest(`/projects/${projectId}/recipes`);
  },

  get(projectId, productId) {
    return apiRequest(`/projects/${projectId}/recipes/${safeId(productId)}`);
  },

  save(projectId, productId, ingredients) {
    return apiRequest(`/projects/${projectId}/recipes/${safeId(productId)}`, {
      method: "PUT",
      body: JSON.stringify({ ingredients }),
    });
  },

  remove(projectId, productId) {
    return apiRequest(`/projects/${projectId}/recipes/${safeId(productId)}`, {
      method: "DELETE",
    });
  },
};
